/**
 * Full-page navigation. Unlike router.push, this reloads the app so every
 * store restarts from scratch — for dead-end states no soft reset covers.
 */
export function hardNavigate(path: string) {
  window.location.href = path;
}
